import { render, staticRenderFns } from "./DateFieldtype.vue?vue&type=template&id=c827c3e6&"
import script from "./DateFieldtype.vue?vue&type=script&lang=js&"
export * from "./DateFieldtype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports